import DistrictController from "./district-controller";

export {DistrictController};
